import { AlertTriangle, X } from "lucide-react";

/** Compact inline alert for roster actions — stays in the form, easy to spot. */
export default function RosterInlineAlert({ error, onDismiss }) {
  if (!error?.message) return null;

  const title =
    error.title ||
    (error.code ? String(error.code).replace(/_/g, " ") : "Could not save assignment");

  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 shadow-sm"
    >
      <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5 text-amber-600" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="font-semibold capitalize leading-tight">{title}</p>
        <p className="mt-0.5 text-amber-800 leading-snug">{error.message}</p>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded p-0.5 text-amber-700/70 hover:text-amber-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}

export function RosterFieldError({ message }) {
  if (!message) return null;
  return (
    <p className="mt-1 text-xs font-medium text-amber-700" role="status">
      {message}
    </p>
  );
}
